/* istanbul ignore file */

export const HEADING = 'We couldn’t find anything for';
export const TRY_AGAIN_INFO = 'Try searching again with a different keyword.';
